namespace RioERP.Reports {
    export interface OrderInstallmentReportRow {
        Id?: number;
        OrderId?: number;
        OrderDate?: string;
        OrderNumber?: string;
        CustomerName?: string;
        CustomerMobile1?: string;
        CustomerEmail1?: string;
        ProductName?: string;
        ProductSpecificationName?: string;
        InstallmentDate?: string;
        GrossAmount?: number;
        InstallmentAmount?: number;
    }

    export namespace OrderInstallmentReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Reports.OrderInstallmentReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderDate = "OrderDate",
            OrderNumber = "OrderNumber",
            CustomerName = "CustomerName",
            CustomerMobile1 = "CustomerMobile1",
            CustomerEmail1 = "CustomerEmail1",
            ProductName = "ProductName",
            ProductSpecificationName = "ProductSpecificationName",
            InstallmentDate = "InstallmentDate",
            GrossAmount = "GrossAmount",
            InstallmentAmount = "InstallmentAmount"
        }
    }
}
